export default {
  home: [
    {
      step: 1,
      message: `While you’re using Mana, I will always be here, wherever you are. Tap me anytime for more options & help. 

I’ll also let you know when I need your attention!`,
      action: {
        text: "Next",
      },
    },
    {
      step: 2,
      message: "Let’s start by setting a goal!",
    },
  ],
  resolution: [
    {
      step: 1,
      message:
        "Tap me! I’m the best way to get anything done anywhere in the app!",
    },
    {
      step: 2,
      message:
        "You’ll see progress towards your new goal here and daily pace needed to achieve it.",
      action: {
        text: "Finish",
      },
    },
  ],
  resolution_picker: [
    {
      step: 1,
      message: `Here’s where you’ll choose what you want to spend more or less time on. 

      Let’s start by setting a goal to reflect on your time - that’s the first step towards time-minfdulness! 
              
      Tap the search bar to find “Reflection.”`,
    },
  ],
  resolution_edit: [
    {
      step: 1,
      message: "Just 15m a week is enough to start a habit!",
      action: {
        text: "Next",
      },
    },
    {
      step: 2,
      message:
        "Choose one or more days for your goal so you know when to check in.",
      action: {
        text: "Next",
      },
    },
    {
      step: 3,
      message:
        "Commit to a month of reflecting for 15m per week. It’s just one hour out of 672!",
      action: {
        text: "Next",
      },
    },
    {
      step: 4,
      message: "The Why and How are **essential** to your success.",
      action: {
        text: "Next",
      },
    },
  ],
  track: [
    {
      step: 1,
      message: `Let’s get tracking! 
- Scroll to the time you woke up today
- Tap “Sleep”, ending when you woke up (We’ll take care of start time in a sec!)`,
    },
    {
      step: 2,
      message:
        "Great, you’ve just marked the end of your good night’s rest! Tap the time expander to choose the time you went to bed.",
    },
    {
      step: 3,
      message:
        "Tap the Start time when you went to bed to update your “Sleep” entry.",
    },
    {
      step: 4,
      message:
        "That was easy! If you ever don’t find the right Element while browsing, you can tap the “More” icon between times. Let’s try it for your next timeslot!",
    },
    {
      step: 5,
      message:
        "Didn’t get a workout in today? Just tap undo to bring back the predictions!",
    },
  ],
  track_edit: [
    {
      step: 1,
      message:
        "Let’s pretend you worked out for 30 minutes when you got up. First, tap the end time [END_TIME].",
    },
    {
      step: 2,
      message: "Tap [END_TIME] to choose it as the end time.",
    },
    {
      step: 3,
      message:
        "Tap “Fitness” from the list of Elements. (You can always open the list or use the search bar to find other Elements!",
    },
  ],
  average_week: [
    {
      step: 1,
      message:
        "Let’s think about where you spent your time last week. Start by estimating how much you slept each night on average.",
    },
    {
      step: 2,
      message:
        "I’ll calculate the weekly hour count based on your daily estimate and mark the row so you know you’ve edited.",
      action: { text: "Next" },
    },
    {
      step: 3,
      message:
        "You can also change the weekly value. Try changing the weekly Job hours",
    },
    {
      step: 4,
      message: "I’ll calculate the average time per day you spent on that.",
      action: { text: "Next" },
    },
    {
      step: 5,
      message:
        "Remove something from the list by swiping left and tapping to confirm.",
      action: { text: "Next" },
    },
    {
      step: 6,
      message: "Tap me to add anything you don’t see",
    },
    {
      step: 7,
      message:
        "Select the Elements that are relevant to your time, then, tap the back arrow",
    },
    {
      step: 8,
      message:
        "Use the Journal icon at the top to reflect on how you felt about the whole week",
    },
    {
      step: 9,
      message:
        "Choose an emoji that’s closest to how you’re feeling and write some notes.",
    },
    {
      step: 10,
      message:
        "Try your best hourly estimates, and I’ll help to make them fit to exactly 1 week!",
      action: { text: "Continue" },
    },
    {
      step: 11,
      message: "When you’re done with all your estimates, tap below!",
      action: { text: "Confirm Estimates" },
    },
  ],
  average_week_details: [
    {
      step: 1,
      message: `
This is where your time went! The bars show the hour differences from last week spent on Health, Work, Fun, and Growth.  

The graph shows the difference from our average for now.`,
      action: {
        text: "Continue",
      },
    },
    {
      step: 2,
      message: `You see all your journals for the selected timeframe here, too! Longpress any journal to update or delete it.`,
      action: {
        text: "Continue",
      },
    },
    {
      step: 3,
      message: `When you’re all done reflecting on the week in broad categories, tap back for a detailed overview of your whole week.`,
    },
  ],
  reflection: [
    {
      step: 1,
      message:
        "The journal icon takes you back to the details screen for any time period you select",
      action: {
        text: "Continue",
      },
    },
    {
      step: 2,
      message:
        "You’ve unlocked Reflection! Scroll through the hour counts to see where your time went last week. ",
      action: {
        text: "Continue",
      },
    },
    {
      step: 3,
      message:
        "Here’s your quick data for Sleep: your 10-period trend (10 weeks since we’re in week view), and hour count. Tap the hour count to view more details.",
    },
    {
      step: 4,
      message: `
You’ll see the journal indictor behind the hour count for that Element. 
Happy Reflecting!`,
      action: {
        text: "Finish",
      },
    },
  ],
  reflection_edit: [
    {
      step: 1,
      message: `You’ll see your data over time in the graph above. Pick an emoji to start a journal and add notes if you like.`,
    },
    {
      step: 2,
      message: `Tap Journal to confirm your entry!`,
    },
  ],
};
